export default __webpack_public_path__ + "static/media/IBimageKneeExtensionTerminalStance1.48db7c03.png";